const SPLASH_HTML_PATH = `${process.env.PUBLIC_URL || ""}/splash/penny-pantry-coin.html`;

export default function LaunchSplash({ leaving = false }) {
  return (
    <div
      className={`launch-splash${leaving ? " leaving" : ""}`}
      aria-hidden="true"
    >
      <div className="launch-splash__fallback">
        <span>PennyPantry</span>
      </div>
      <iframe
        className="launch-splash__frame"
        title="PennyPantry launch animation"
        src={SPLASH_HTML_PATH}
        scrolling="no"
      />
    </div>
  );
}
